import * as React from "react";
import { Col, Row } from "react-bootstrap";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useErrorContext } from "./errorContext";

export default function MessageBox(props) {
  const { setError, setErrorMessage } = useErrorContext();
  return (
    <div
      id="message-box"
      className={"message-box " + (props.messageBoxVisible ? "block-display-visible" : "block-display-hidden")}
    >
      <div>
        <Row className="d-flex align-items-center">
          <Col>
            <b>{props.messageTitle}</b>
          </Col>
          <Col xs={"auto"}>
            <IconButton
              size="small"
              onClick={() => {
                setError(false);
                setErrorMessage("");
                props.setMessageBoxVisible(false);
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Col>
        </Row>
      </div>
      <div>{props.messageBody}</div>
      {props.messageBody2 && <div>{props.messageBody2}</div>}
    </div>
  );
}
